export default __webpack_public_path__ + "static/media/womens-bottom.f61593f7.png";